import { GET } from '../_helpers/Fetch';
import { TOUHISTORY } from '../_constants/TouAPI';
import { UrlFilterHelper } from '_helpers/UrlFilterHelper';

export const touService = {
  GetTouHistory,
  GetTou
}

async function GetTou(id) {
    try {
        const { data: TouHistory } = await GET(TOUHISTORY + `/GetTou/${id}`);
        return TouHistory;
    } catch(err){
        console.log(err);
        return null;
    }   
}

async function GetTouHistory(skipCount, orderBy, dsc) {
    try {
        var url = TOUHISTORY + "/GetAll"
        url = UrlFilterHelper.GetFilterdUrl(url, skipCount, null, orderBy, dsc)
        const { data: PagedTouHistory } = await GET(url);
        return PagedTouHistory;
    } catch (err) {
        return null;
    }
}
